import { types } from "../types/types";
const intitalState = {
    allEmployees: [],
};

const employeeReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_EMPLOYEES:
            return {
                ...state,
                allEmployees: action.payload,
            };
        default:
            return { ...state };
    }
};

export default employeeReducer;
